import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ORDER_SOURCE_TO_CATEGORY } from './traffic-source-classification';

declare var amplitude: any;

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getDeviceType(): string {
    if (!this.isBrowser) return 'unknown';
    
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet';
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(ua)) {
      const os = this.getMobileOperatingSystem();
      if (os === 'Android') return 'android';
      if (os === 'iOS') return 'ios';
      return 'mobile';
    }
    return 'desktop';
  }

  getBrowser(): string {
    if (!this.isBrowser) return 'Unknown';
    
    const ua = navigator.userAgent;
    let browserName = 'Unknown';

    if (ua.search('MSIE') >= 0) {
      browserName = 'Internet Explorer';
    } else if (ua.search('Edge') >= 0) {
      browserName = 'Microsoft Edge';
    } else if (ua.search('Firefox') >= 0) {
      browserName = 'Mozilla Firefox';
    } else if (ua.search('Chrome') >= 0) {
      browserName = 'Google Chrome';
    } else if (ua.search('Safari') >= 0 && ua.search('Chrome') < 0) {
      browserName = 'Apple Safari';
    } else if (ua.search('Opera') >= 0) {
      browserName = 'Opera';
    }

    return browserName;
  }

  getMobileOperatingSystem(): string {
    if (!this.isBrowser) return 'unknown';
    
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return 'unknown';
  }

  amplitudeFunction(event: string, obj: any, deviceType = 'Web'): void {
    if (!this.isBrowser) return;
    try {
      const trafficSource = localStorage.getItem('referrer') || 'Direct';
      let eventProperties: any = {
        'Traffic_Source': trafficSource,
        'Consolidated_Traffic_Source_Category': this.getConsolidatedTrafficSourceCategory(trafficSource),
        'Browser': this.getBrowser(),
        'Device_Type': this.getDeviceType(),
        'URL': window.location.href,
        'Platform_Type': deviceType === 'Web' ? deviceType : 'App' + this.getMobileOperatingSystem(),
      };

      eventProperties = { ...eventProperties, ...obj };

      amplitude.getInstance().logEvent(event, eventProperties);
    } catch (exp) {
      // Silent fail
    }
  }

  // add user id to amplitude
  setUserId(userId: string): void {
    if (!this.isBrowser) return;
    try {
      amplitude.getInstance().setUserId(userId);
    } catch (exp) {
      // Silent fail
    }
  }

  /**
   * Maps order source (Traffic_Source) to consolidated category per Marketing Attribution Dashboard.
   * Falls back to 'Others' when not in the classification map.
   */
  getConsolidatedTrafficSourceCategory(trafficSource: string | null): string {
    if (trafficSource == null || trafficSource === '') {
      return 'Others';
    }
    const key = trafficSource.trim();
    return ORDER_SOURCE_TO_CATEGORY[key] ?? 'Others';
  }
}

